import { styled } from 'linaria/react';
import Button from '../Button/Button';
const commonStyles = `
  font-size: 1rem;
  border: 1px solid transparent;
  padding: 1rem;
  /* Button is a child of a flex container, so this aligns to bottom */
  margin-top: auto;
  width: 100%;
`;
export const CommitButton = /*#__PURE__*/styled(Button)({
  name: "CommitButton",
  class: "cp1f0ra"
});
export const CancelButton = /*#__PURE__*/styled(Button)({
  name: "CancelButton",
  class: "c1d3sy9"
});

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ChannelSelector/ChannelSelectorButtons.linaria.css");